import { gql } from '__generated__';

export default gql(`
  query GetParticipantFieldStats($id: ID!, $tickets: [ID!]) {
    participantField(id: $id) {
      id
      type
      choices {
        id
        title
        enabled
        choice_entry_count(tickets: $tickets)
      }
    }
  }
`);
